<div class="courses-not-found-wrapper">
  <div class="otto">
    <img
      src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/otto-icons/otto-not-found-icon.svg"
    />
  </div>
  <div class="text-wrapper">
    <h1>Ops!</h1>
    <p>
      Não foram encontrados resultados para sua busca. <br />Que tal procurar
      por outro termo?
    </p>
  </div>
</div>
